module.exports = __webpack_public_path__ + "static/img/auth_card_down.f870f665.png";